import {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {workingHoursApi} from 'api';
import {Card, DataWrapper, PredefinedNotifierType, UserSelector} from 'components';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {WorkingHours as WorkingHoursType} from 'types';

import {BaseWorkingHours} from '../BaseWorkingHours';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.WORKING_HOURS.USER_HOURS;

export const UserWorkingHours: React.FC = () => {
    const {t} = useTranslation();
    const [userEid, setUserEid] = useState<number>(null);

    const {send: getWorkingHours, data: workingHours, loading: getLoading} = useApiData(workingHoursApi.getForUser, {
        notificationType: PredefinedNotifierType.FetchError
    });
    const loadWorkingHours = useCallback(() => getWorkingHours(+userEid), [userEid, getWorkingHours]);

    const {send: updateWorkingHours, loading: updateLoading} = useApiData(workingHoursApi.updateForUser, {
        onSuccess: loadWorkingHours,
        notificationType: PredefinedNotifierType.Save
    });

    const handleSubmit = useCallback((formData: WorkingHoursType) => {
        updateWorkingHours(formData, +userEid);
    }, [updateWorkingHours, userEid]);

    useEffect(() => {
        if (userEid) {
            loadWorkingHours();
        }
    }, [userEid, loadWorkingHours]);

    return (
        <div className='tw-relative'>
            <UserSelector
                value={userEid}
                className='tw-w-64'
                onChange={setUserEid}
            />
            {!userEid && <div className='tw-ts-h5 tw-my-4'>{t(T_KEYS.EMPTY_USER)}</div>}
            {userEid &&
                <Card className='tw-mt-4'>
                    <DataWrapper isLoading={getLoading || updateLoading}>
                        <BaseWorkingHours
                            workingHours={workingHours}
                            loading={getLoading || updateLoading}
                            onSubmit={handleSubmit}
                        />
                    </DataWrapper>
                </Card>}
        </div>
    );
};